/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment';
import { NDC_TABS_DATA } from '../../../Display/NDC/utility/constants';
import {
  NDCORClaimRadioData,
  RegularSuppData,
  SelectedClaimModeDataNu,
} from '../utils/constant';
import * as TYPES from './action-types';

const intialState = {
  successMessage: null,
  errorPopupMessage: null,
  claimCategoryCode: 0,
  loading: false,
  invoiceSelected: { invoiced: true, nonInvoiced: false },
  selectedClaimNDCTab: '',
  searchByDrugNameTableData: [],
  labelerTableData: [],
  labelerDrugTableData: [],
  claimDetailsTableData: [],
  claimSelectByFilter: {},
  claimDetailsTableRowSelected: [],
  rebateType: RegularSuppData[0].value,
  selectBy: NDCORClaimRadioData[0].value,
  suppRadioDisable: false,
  claimDetailsPopup: { open: false, total: 0, data: null },
  claimReferenceData: null,
  providerIdTypeDropdown: [],
  categoryCodeDropdown: [],
  generalSystemParameter: [],
  rebateProgramDropdown: [],
  clientDropdown: [],
  groupDropdown: [],
  planDropdown: [],
  // Selected Claim State Below
  selectedClaimNu: [],
  selectedClaimIndex: 1,
  selectedClaimFilterNu: { invoiceSelected:{invoiced: true, nonInvoiced: true }},
  selectedClaimModeNu: SelectedClaimModeDataNu[0].value,
  selectedClaimRecordIndex: null,
  enteredNdc: null,
  disableBtn: true,
  disputeResolutionToggle: false,
  tableDataNu: [],
  editedData: [],
  claimId: '',
  extraState: {
    fullScreenView: false,
    edit: false,
  },
  errorMessage: [],
  unitResponse: {},
  cellFocused: -1,

  pageClaimDataNu: [{ claimResultVOList: [] }],
  searchScreenReduxObj: {
    isibwdndc: false,
    isibwdclaim: false,
  },
};

const reducer = (state = intialState, action) => {
  switch (action.type) {
    case TYPES.SET_CLAIM_ID:
      return { ...state, claimId: action.payload };
    case TYPES.CLAIM_LOADING:
      return { ...state, loading: action.payload };
    case TYPES.SELECTED_CLAIM_MODE_NU:
      return { ...state, selectedClaimModeNu: action.payload };
    case TYPES.SELECTED_CLAIM_INDEX:
      return { ...state, selectedClaimIndex: action.payload };
    case TYPES.SELECTED_CLAIM_FILTER_NU:
      return { ...state, selectedClaimFilterNu: action.payload };
    case TYPES.CUSTOM_NOU_CLAIM_TABLE_LOAD:
      return { ...state, getNouClaimInfo: action.payload };
    case TYPES.NUMBER_OF_UNITS_SELECT_BY:
      return { ...state, selectBy: action.payload };
    case TYPES.CLAIM_DETAILS_POPUP:
      return { ...state, claimDetailsPopup: action.payload };
    case TYPES.CLAIM_SUPP_RADIO_DISABLE:
      return { ...state, suppRadioDisable: action.payload };
    case TYPES.CLAIM_REFERENCE_DATA:
      return { ...state, claimReferenceData: action.payload };
    case TYPES.CLAIM_INVOICED_SELECTED:
      return { ...state, invoiceSelected: action.payload };
    case TYPES.CLAIM_REBATE_TYPE:
      return { ...state, rebateType: action.payload };
    case TYPES.SELECTED_CLAIM_NU:
      return { ...state, selectedClaimNu: action.payload };
    case TYPES.CLAIM_PROVIDER_ID_TYPE_DROPDOWN:
      return { ...state, providerIdTypeDropdown: action.payload };
    case TYPES.CLAIM_CATEGORY_CODE_DROPDOWN:
      return { ...state, categoryCodeDropdown: action.payload };
    case TYPES.CLAIM_REBATE_PROGRAM_DROPDOWN:
      return { ...state, rebateProgramDropdown: action.payload };
    case TYPES.CLAIM_CLIENT_DROPDOWN:
      return { ...state, clientDropdown: action.payload };
    case TYPES.CLAIM_GROUP_DROPDOWN:
      return { ...state, groupDropdown: action.payload };
    case TYPES.CLAIM_PLAN_DROPDOWN:
      return { ...state, planDropdown: action.payload };
    case TYPES.CLAIM_GENERAL_PARAMETERS:
      return { ...state, generalSystemParameter: action.payload };
    case TYPES.CLAIM_SUCCESS_MESSAGE:
      return { ...state, successMessage: action.payload };
    case TYPES.CLAIM_ERROR_POPUP_MESSAGE:
      return { ...state, errorPopupMessage: action.payload };
    case TYPES.CLAIM_SELECTED_NDC_TAB:
      return { ...state, selectedClaimNDCTab: action.payload };
    case TYPES.CLAIM_SEARCH_BY_DRUG_NAME_TABLE_DATA:
      return { ...state, searchByDrugNameTableData: action.payload };
    case TYPES.CLAIM_LABELER_TABLE_DATA:
      return { ...state, labelerTableData: action.payload };
    case TYPES.CLAIM_LABELER_DRUG_TABLE_DATA:
      return { ...state, labelerDrugTableData: action.payload };
    case TYPES.CLAIM_DETAILS_TABLE_DATA:
      return { ...state, claimDetailsTableData: action.payload };
    case TYPES.CLAIM_DETAILS_TABLE_ROW_SELECTED:
      return { ...state, claimDetailsTableRowSelected: action.payload };
    case TYPES.CLAIM_SELECT_BY_FILTER:
      return { ...state, claimSelectByFilter: action.payload };
    case TYPES.CLAIM_CATEGORY_CODE:
      return { ...state, claimCategoryCode: action.payload };
    case TYPES.CLAIM_SELECTED_RECORD_INDEX:
      return { ...state, selectedClaimRecordIndex: action.payload };
    case TYPES.ENTERED_NDC:
      return { ...state, enteredNdc: action.payload };
    case TYPES.SET_DISABLED_BUTTON:
      return { ...state, disableBtn: action.payload };
    case TYPES.DISPUTE_RESOLUTION_TOGGLE:
      return { ...state, disputeResolutionToggle: action.payload };
    case TYPES.SET_TABLE_DATA_NU:
      return {
             ...state,
             tableDataNu: action.payload?.map((item) => {
               item.mcoPaidDt =
                 item.mcoPaidDt && item.mcoPaidDt !== 'Invalid Date'
                   ? moment(item.mcoPaidDt).format('MM/DD/yyyy')
                   : null;
               item.paidDt =
                 item.paidDt && item.paidDt !== 'Invalid Date'
                   ? moment(item.paidDt).format('MM/DD/yyyy')
                   : null;
               item.serviceDt =
                 item.serviceDt && item.serviceDt !== 'Invalid Date'
                   ? moment(item.serviceDt).format('MM/DD/yyyy')
                   : null;
               item.billedUnits = item.billedUnits
                 ? parseFloat(item.billedUnits)?.toFixed(4)
                 : '0.0000';
               item.origNumOfUnits = item.origNumOfUnits
                 ? parseFloat(item.origNumOfUnits)?.toFixed(4)
                 : '0.0000';
               item.numOfUnits = item.numOfUnits
                 ? parseFloat(item.numOfUnits)?.toFixed(4)
                 : '0.0000';
               item.billedUnits = item.billedUnits
                 ? parseFloat(item.billedUnits)?.toFixed(4)
                 : '0.0000';
               item.hcpcsUnits =
                 item.hcpcsUnits !== null && item.hcpcsUnits !== undefined
                   ? parseFloat(item.hcpcsUnits)?.toFixed(4)
                   : '0.0000';
               item.tplAmt = item.tplAmt
                 ? parseFloat(item.tplAmt)?.toFixed(2)
                 : '0.00';
               item.copayAmt = item.copayAmt
                 ? parseFloat(item.copayAmt)?.toFixed(2)
                 : '0.00';
               item.deductibleAmt = item.deductibleAmt
                 ? parseFloat(item.deductibleAmt)?.toFixed(2)
                 : '0.00';
               item.deductibleAmt = item.deductibleAmt
                 ? parseFloat(item.deductibleAmt)?.toFixed(2)
                 : '0.00';
               item.reversingClaimId = item.reversingClaimId; // ? 1 : 0;
               item.planId =
                 !item.clientId && !item.groupId && !item.planId
                   ? ''
                   : `${item.clientId}-${item.groupId}-${item.planId}`;
               return item;
             }),
           };
    case TYPES.UNIT_LOADING:
      return { ...state, untiLoading: action.payload };
    case TYPES.UNIT_RESPONSE: {
      return { ...state, unitResponse: { ...action.payload } };
    }
    case TYPES.SET_EDITED_DATA_NU: {
      return { ...state, selectedClaimNu: action.payload };
    }
    case TYPES.NUMOFUNITS_EXTRA_STATE:
      return { ...state, extraState: action.extraState };
    case TYPES.RESET_SELECT_CLAIM_DATA_NU:
      return {
        ...state,
        successMessage: null,
        errorPopupMessage: null,
        loading: false,
        invoiceSelected: { invoiced: true, nonInvoiced: false },
        selectedClaimNDCTab: '',
        searchByDrugNameTableData: [],
        labelerTableData: [],
        labelerDrugTableData: [],
        claimDetailsTableData: [],
        claimSelectByFilter: {},
        claimDetailsTableRowSelected: [],
        rebateType: RegularSuppData[0].value,
        selectBy: NDCORClaimRadioData[0].value,
        suppRadioDisable: false,
        claimDetailsPopup: { open: false, total: 0, data: null },
        claimId: null,
        selectedClaimNu: intialState.selectedClaimNu,
        selectedClaimIndex: intialState.selectedClaimIndex,
        selectedClaimFilterNu: intialState.selectedClaimFilterNu,
        selectedClaimModeNu: intialState.selectedClaimModeNu,
      };
    case TYPES.SET_EDITED_ROWS:
      return { ...state, editedData: action.payload };
    case TYPES.RESET_EDITED_ROWS:
      return { ...state, editedData: [] };
    case TYPES.SET_ERROR_MESSAGE: {
      return { ...state, errorMessage: action.errorMessage };
    }
    case TYPES.SET_CELL_FOCUSED: {
      return { ...state, cellFocused: action.payload };
    }
    case TYPES.SET_SINGLE_PAGE_CLAIM_DATA_NU: {
      return {
        ...state,
        pageClaimDataNu: [{ claimResultVOList: action.payload }],
      };
    }
    case TYPES.NO_OF_UNITS_SEARCH_TAB_DATA: {
      return { ...state, searchScreenReduxObj: action.searchScreenReduxObj };
    }
    case TYPES.CLEAR_REDUX_DATA_CLAIM: {
      return {
        ...intialState,
      };
    }
    default:
      return state;
  }
};
export default reducer;
